function hideMapBlock() {
    document.querySelector('.map__main').style.display = 'none';
}

const MapInitializer = () => {
    let latitude = parseFloat(document.getElementById('address-page-map').dataset.latitude);
    let longitude = parseFloat(document.getElementById('address-page-map').dataset.longitude);
    let coordinates = [latitude, longitude];
    let isPanoramaVisible = false;
    let panoramaPlayer = null;
    let myMap = null;
    let panoramasData = null;

    ymaps.ready(function () {
        if (isNaN(latitude) || isNaN(longitude) || latitude === 0 || longitude === 0) {
            console.log("Невалидные координаты");
            hideMapBlock();
            return;
        }
        myMap = new ymaps.Map("YMapsID", {
            center: coordinates,
            zoom: 15,
            controls: ['zoomControl', 'fullscreenControl'],
            trafficControl: false
        });

        let address = document.getElementById('address-page-map').dataset.address;
        let placemark = new ymaps.Placemark(coordinates, {
            hintContent: address,
            balloonContent: address
        }, {
            preset: 'islands#blueIcon',
            iconColor: '#4a9cf9'
        });

        myMap.geoObjects.add(placemark);
        initPanorama();
        initOpenMapButton(myMap);
    });

    function initOpenMapButton(myMap) {
        const button = document.querySelector('.main-button.white.openMap');
        const mapContainer = document.getElementById('address-page-map');
        const originalHeight = mapContainer.style.height;
        button.addEventListener('click', function () {
            if (mapContainer.style.height === '500px') {
                mapContainer.style.height = originalHeight;
                button.textContent = 'Открыть карту';
                myMap.container.fitToViewport();
            } else {
                mapContainer.style.height = '500px';
                button.textContent = 'Закрыть карту';
                myMap.container.fitToViewport();
            }
        });
    }

    function initPanorama() {
        ymaps.panorama.locate(coordinates).then(
            function (panoramas) {
                if (panoramas.length) {
                    panoramasData = panoramas[0];
                    console.log("Данные панорамы успешно загружены");
                } else {
                    console.log("Для заданной точки не найдено ни одной панорамы.");
                    document.getElementById('togglePanorama').style.display = 'none';
                }
            },
            function (error) {
                console.log("Ошибка при загрузке данных панорамы:", error);
                document.getElementById('togglePanorama').style.display = 'none';
            }
        );

        document.getElementById('togglePanorama').addEventListener('click', togglePanoramaVisibility);
    }

    function togglePanoramaVisibility() {
        const panoramaContainer = document.getElementById('panorama');
        const mapContainer = document.getElementById('YMapsID');
        const toggleButton = document.getElementById('togglePanorama');

        if (isPanoramaVisible) {
            mapContainer.style.display = 'block';
            panoramaContainer.style.display = 'none';
            toggleButton.textContent = 'Показать панораму';

            if (myMap) {
                myMap.container.fitToViewport();
            }

            if (panoramaPlayer) {
                panoramaPlayer.destroy();
                panoramaPlayer = null;
            }
        } else {
            mapContainer.style.display = 'none';
            panoramaContainer.style.display = 'block';
            toggleButton.textContent = 'Показать карту';

            if (panoramasData && !panoramaPlayer) {
                createPanoramaPlayer();
            }
        }

        isPanoramaVisible = !isPanoramaVisible;
    }


    function createPanoramaPlayer() {
        const panoramaContainer = document.getElementById('panorama');
        panoramaContainer.innerHTML = '';

        panoramaPlayer = new ymaps.panorama.Player(
            'panorama',
            panoramasData,
            {
                direction: [0, -50],
                controls: ['zoomControl', 'fullscreenControl']
            }
        );
    }
}

function loadYandexMapsApi(callback) {
    if (window.ymaps) {
        callback();
        return;
    }
    const script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1?apikey=df0e48a9-d0fd-46a1-9159-f359bf432765&lang=ru_RU&load=Map,Placemark,control.Manager,control.ZoomControl,control.FullscreenControl,panorama.locate,panorama.Player';
    script.type = 'text/javascript';
    script.onload = callback;
    script.onerror = hideMapBlock;
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', () => {
    const isAddressThemeV1 = document.body.classList.contains('address-theme--v1');
    const mapBlock = document.getElementById('address-page-map');
    if (!mapBlock || !isAddressThemeV1) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                obs.disconnect();
                loadYandexMapsApi(MapInitializer);
            }
        });
    }, {threshold: 0.1});

    observer.observe(mapBlock);
});
